import * as accessibilityScans from '@wix/auto_sdk_accessibility_accessibility-scans';

export { accessibilityScans };
